import styled from 'styled-components';
import { COLORS } from '../utils/styled';
export const Badge = styled.div `
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0.5rem;
    font-size: 1rem;
    line-height: 1rem;
    color: ${COLORS.White};
    background: rgba(0, 0, 0, 0.1);
    box-shadow: 0px 0.125rem 0.125rem rgba(0, 0, 0, 0.05);
    backdrop-filter: blur(3.125rem);
    -webkit-backdrop-filter: blur(3.125rem);
    border-radius: 0.375rem;
`;
export const BroadcastName = styled.h2 `
    color: #ffffff;
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;

    &:empty {
        display: none;
    }
`;
